import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_CREATE_RAZORPAY_ORDER, RQ_GET_ORDER_BY_USER_ID, RQ_ORDER_REGISTRATION_API, RQ_VERIFY_RAZORPAY_PAYMENT} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetOrderByUserId = (id, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_order_by_useid', {id, token}],
    queryFn: async ({queryKey, signal}) => {
      const {id, token} = queryKey[1];

      if (!token) { throw new Error('Invalid token: Token is required for API request'); }

      const url = RQ_GET_ORDER_BY_USER_ID.url.replace('<%= id %>', id);

      // eslint-disable-next-line no-useless-catch
      try {
        const response = await rqCreateRequest(
          {...RQ_GET_ORDER_BY_USER_ID, url},
          null,
          token,
          null,
          signal,
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    ...options,
  });
};

export const RQOrderRegistration = (token, options = {}) => {
  return useMutation({
    mutationKey: ['rq_order_registration'],
    mutationFn: async formData => {
      if (!token) {
        throw new Error('Invalid token: Token is required for API request');
      }
      if (!formData) {
        throw new Error('formData is undefined');
      }
      return rqCreateRequest(RQ_ORDER_REGISTRATION_API, formData, token);
    },
    ...options,
  });
};

export const RQCreateRazorpayOrder = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_create_razorpay_order'],
    mutationFn: async ({token, orderId, amount}) => {
      return rqCreateRequest(
        RQ_CREATE_RAZORPAY_ORDER,
        {
          orderId:orderId,
          amount: amount},
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQVerifyRazorpayPayment = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_verify_razorpay_payment'],
    mutationFn: async ({token, formData}) => {

      return rqCreateRequest(
        RQ_VERIFY_RAZORPAY_PAYMENT,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};
